import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  gap: 16px;
`;

export const SpinnerRing = styled.div`
  display: inline-block;
  position: relative;
  width: ${props => {
    switch (props.size) {
      case 'small': return '24px';
      case 'large': return '48px';
      default: return '32px';
    }
  }};
  height: ${props => {
    switch (props.size) {
      case 'small': return '24px';
      case 'large': return '48px';
      default: return '32px';
    }
  }};

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: ${props => {
      switch (props.size) {
        case 'small': return '2px';
        case 'large': return '4px';
        default: return '3px';
      }
    }} solid ${props => props.color}20;
    border-top-color: ${props => props.color};
    border-radius: 50%;
    animation: ${spin} 1s linear infinite;
  }
`;

export const LoadingText = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  text-align: center;
  letter-spacing: 0.025em;
`;